import '../styles/bootstrap_styles.css';
import '@natscale/react-calendar/dist/main.css';
import Top from './top';
import Header from './header';
import Inicio from './front/inicio';
import Curso from './front/curso';
import Calendario from './front/calendario';
import Contacto from './front/contacto';
import Footer from './footer';

// 1. 팝업에 상세정보(완료)
// 2. 달력 UI
// 3. 달력에 입력해야할 관리자 화면 추가
// 4. whatsapp 연동 - 메세지 전송 기능만 추가(완료)

function Index() {
    return (
        <>
          <Top />
          <Header />
          <Inicio />
          <Curso />
          <Calendario />
          <Contacto />
          <Footer />
                
        <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js"></script>
        
        <script src="js/scripts.js"></script>
        <script src="https://cdn.startbootstrap.com/sb-forms-latest.js"></script>
        </>
    );
  }

export default Index;